import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Wrapper from "../common/Wrapper";
import Header from "../common/Header";
import Loader from "../Parts/Loader";

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },
});

class SamlAuthenticated extends React.Component {

  componentDidMount() {
    // SAML認証済みイベント
    // ログインセッションがあれば自動的にログインし
    // なければログイン画面へリダイレクト
    this.props.samlAuthenticated();
  }

  renderLoading = () => (
    <div className={this.props.classes.box}>
      <Loader type="color" />
    </div>
  );

  render() {
    const { classes } = this.props;

    return (
      <Wrapper className={classes.root}>
        <Header
          title="SAML認証"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() =>
            this.props.goTo("/")
          }
        />
        <div className={classes.content}>
          {(() => {
            return this.renderLoading();
          })()}
        </div>
      </Wrapper>
    );
  }
}

SamlAuthenticated.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
  samlAuthenticated: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
};

export default withStyles(styles)(SamlAuthenticated);



// WEBPACK FOOTER //
// ./src/components/SamlAuthenticated/SamlAuthenticated.jsx